import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import ProstoHome from "@/prosto/ProstoHome";
import ProstoAppDetail from "@/prosto/ProstoAppDetail";
import ProstoSearch from "@/prosto/ProstoSearch";
import ProstoCategory from "@/prosto/ProstoCategory";
import ProstoGuide from "@/prosto/ProstoGuide";
import { getTelegramWebApp } from "@/lib/telegram";

export default function ProstoApp() {
  useEffect(() => {
    const tg = getTelegramWebApp();
    if (tg) {
      try {
        tg.setBackgroundColor("#f5f6f8");
        tg.setHeaderColor("#ffffff");
      } catch (e) {
        /* older clients */
      }
    }
  }, []);

  return (
    <div className="prosto-shell">
      <Routes>
        <Route index element={<ProstoHome />} />
        <Route path="app/:id" element={<ProstoAppDetail />} />
        <Route path="search" element={<ProstoSearch />} />
        <Route path="category/:name" element={<ProstoCategory />} />
        <Route path="guide" element={<ProstoGuide />} />
      </Routes>
    </div>
  );
}
